/* Vestiganga Mayorista — JS liviano, sin librerías */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Toast ---------- */
  var tt;
  function toast(html) {
    var el = $('[data-vg-toast]');
    if (!el) { el = document.createElement('div'); el.className = 'vg-toast'; el.setAttribute('role', 'status'); el.setAttribute('data-vg-toast', ''); document.body.appendChild(el); }
    el.innerHTML = html; el.classList.add('is-on');
    clearTimeout(tt); tt = setTimeout(function () { el.classList.remove('is-on'); }, 2600);
  }

  /* ---------- Header ---------- */
  function initHeader() {
    var btn = $('[data-vg-menubtn]'), nav = $('[data-vg-mnav]');
    if (btn && nav && !btn.dataset.bound) {
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var open = nav.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      nav.addEventListener('click', function (e) {
        if (e.target.closest('a')) { nav.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
      });
    }
    var ann = $('[data-vg-header] .vg-announce');
    var setTop = function () { document.documentElement.style.setProperty('--vg-sticky-top', ann ? (-ann.offsetHeight) + 'px' : '0px'); };
    setTop(); window.addEventListener('resize', setTop);
  }

  /* ---------- Money ---------- */
  function formatMoney(cents, format) {
    format = format || '${{amount}}';
    var value = '';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function fmt(n, dec, th, ds) {
      dec = isNaN(dec) ? 2 : dec; th = th || ','; ds = ds || '.';
      if (isNaN(n) || n == null) return 0;
      n = (n / 100).toFixed(dec);
      var parts = n.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (parts[1] ? ds + parts[1] : '');
    }
    var m = format.match(placeholder);
    switch (m ? m[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ''); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }

  /* Prendas reales del carrito: una línea de paquete fijo "Docena (12)" cuenta cantidad × 12. */
  window.vgPrendas = function (c) {
    var t = 0;
    ((c && c.items) || []).forEach(function (it) {
      var u = 0;
      (it.options_with_values || []).forEach(function (o) { if (/^paquetes?$/i.test(String(o.name).trim())) { var m = String(o.value).match(/\((\d+)\)/); if (m) u = Number(m[1]); } });
      t += it.quantity * (u || 1);
    });
    return t;
  };
  function refreshCartCount() {
    return fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { $$('[data-vg-cart-count]').forEach(function (e) { e.textContent = window.vgPrendas(c); }); return c; });
  }


  /* ---------- Mi pedido (carrito oficial de Shopify) ---------- */
  function initCart(root) {
    if (root.dataset.bound) return; root.dataset.bound = '1';
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    function change(line, q) {
      root.classList.add('is-busy');
      fetch(base + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(line), quantity: Math.max(0, q) }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j.description || res.j.message || 'No se pudo actualizar el pedido');
          return fetch(window.location.pathname + '?section_id=' + encodeURIComponent(root.dataset.sectionId)).then(function (r) { return r.text(); });
        })
        .then(function (html) {
          var d = document.createElement('div'); d.innerHTML = html;
          var n = d.querySelector('[data-vg-cart]');
          if (n) { root.replaceWith(n); initCart(n); } else { window.location.reload(); }
          refreshCartCount();
        })
        .catch(function (e) {
          root.classList.remove('is-busy');
          var m = $('[data-vg-cart-msg]', root); if (m) { m.hidden = false; m.className = 'vg-msg vg-msg--err'; m.textContent = e.message; }
        });
    }
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-vg-cq]'); if (!b) return;
      var holder = b.dataset.line ? b : b.closest('[data-line]');
      change(holder.dataset.line, Number(b.dataset.vgCq));
    });
    root.addEventListener('change', function (e) {
      var i = e.target.closest('[data-vg-cq-input]'); if (!i) return;
      change(i.closest('[data-line]').dataset.line, Math.floor(Number(i.value) || 0));
    });
  }


  /* ---------- Registro mayorista → WhatsApp ---------- */
  function initRegister(f) {
    if (f.dataset.bound) return; f.dataset.bound = '1';
    f.addEventListener('submit', function (e) {
      e.preventDefault();
      var err = $('[data-vg-register-err]', f), ok = true, lines = [f.dataset.intro || 'Hola Vestiganga.'];
      $$('input, select', f).forEach(function (el) {
        var v = (el.value || '').trim();
        if (el.required && !v) ok = false;
        if (v) lines.push(el.name + ': ' + v);
      });
      if (err) err.hidden = ok;
      if (!ok) return;
      window.open('https://wa.me/' + f.dataset.wa + '?text=' + encodeURIComponent(lines.join('\n')), '_blank', 'noopener');
    });
  }

  window.VG = window.VG || {};
  VG.$ = $; VG.$$ = $$; VG.toast = toast; VG.formatMoney = formatMoney; VG.refreshCartCount = refreshCartCount;

  function init() {
    initHeader();
    $$('[data-vg-cart]').forEach(initCart);
    $$('[data-vg-register]').forEach(initRegister);
    if (window.VG && VG.initPage) VG.initPage();
  }
  /* Contador del header cuando el carrito del tema base cambia (página de carrito) */
  document.addEventListener('cart:update', function () { refreshCartCount(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();